import React, { useContext, useState, useEffect, useRef } from "react";
import { TemplateContext } from "../../layout";
import VariantOption from "./VariantOption";

const VariantSelect = ({ data, id, size, type, itemKey }) => {
  const [templateContext, setTempalateContext, variantsContext, setVariantsContext] = useContext(TemplateContext);
  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const variantsBase = window.post_template?.checkout_v4_products;
  const itemLabel = variantsBase?.tr_checkout_v4_variantsItemLabel;
  const selectRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (type == "color") {
      setSelectedData(
        window.productData?.product_color_variants.find((item) => {
          return item?.value == variantsContext?.variants[itemKey]?.color;
        })
      );
    }
    if (type == "size") {
      setSelectedData(
        window.productData?.product_size_variants.find((item) => {
          return item?.value == variantsContext?.variants[itemKey]?.size;
        })
      );
    }
  }, [variantsContext?.variants[itemKey]]);

  return (
    <div
      ref={selectRef}
      className={`${
        open ? "variant-select--active variant-select" : "variant-select--passive variant-select"
      } variant-select--${size}`}
      onClick={() => {
        setOpen(!open);
      }}
    >
      <div className="variant-select--label">
        <span>
          {Number(itemKey) + 1} {itemLabel}
        </span>
        <div className="variant-select--chevron" data-expanded={open}>
          <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.99999 5.5C4.84317 5.5 4.68637 5.43998 4.56681 5.32018L0.804499 1.5486C0.565167 1.30868 0.565167 0.919689 0.804499 0.679867C1.04373 0.440044 1.43169 0.440044 1.67104 0.679867L4.99999 4.01717L8.32895 0.679983C8.56828 0.440161 8.9562 0.440161 9.19541 0.679983C9.43486 0.919806 9.43486 1.30879 9.19541 1.54871L5.43316 5.3203C5.31354 5.44011 5.15675 5.5 4.99999 5.5Z"
              fill="#828282"
            />
          </svg>
        </div>
      </div>
      <div className="custom-select">
        {type == "color" && (
          <div className="custom-select__colorIndicator" style={{ backgroundColor: selectedData?.color_hex }}></div>
        )}
        <div className="variant-text--placeholder">{selectedData?.tr_label}</div>
      </div>
      {open && (
        <div className="custom-select--hidden">
          <div className="custom-select__wrapper">
            <ul className="custom-select__inner">
              {data &&
                data.map((item, index) => {
                  return (
                    <VariantOption
                      key={index}
                      label={item?.tr_label}
                      color={item?.color_hex}
                      type={type}
                      value={item?.value}
                      currentSelect={selectedData}
                      handleClick={(value, type, label) => {
                        setVariantsContext((prevProductContext) => {
                          const updatedVariants = prevProductContext?.variants?.map((variant, key) => {
                            if (type == "size" && key == itemKey) {
                              return {
                                ...variant,
                                size: value,
                                sizeLabel: label,
                              };
                            }
                            if (type == "color" && key == itemKey) {
                              return {
                                ...variant,
                                color: value,
                                colorLabel: label,
                              };
                            }
                            return variant;
                          });

                          return {
                            ...prevProductContext,
                            variants: updatedVariants,
                          };
                        });
                      }}
                    />
                  );
                })}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default VariantSelect;
